module.exports = __webpack_public_path__ + "img/front_closure_length.86db28a1.png";